import React, { Component, Fragment } from 'react'
import { BreadCrumb, Card, Loading } from '../../components'
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext'
import { UserService } from '../../services/UserService';
export class BankAccount extends Component {
    constructor() {
        super();

        this.state = {
            loading: false,
            bankAccounts: []
        }

    }
    componentDidMount() {

        this.setState({ loading: true }, () => {
            UserService.BankAccounts().then(response => {

                if (response) {

                    this.setState({ bankAccounts: response });
                }

                this.setState({ loading: false });
            });
        });
    }
    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={Translate('Bank Account')} Name={Translate('Bank Account')} />
                        {this.state.bankAccounts.map((item, index) => (
                            <Card key={index}>
                                <div className="row">
                                    <div className="col-md-2 bank-logo">
                                        <img src={item.logo} width="150" alt="Logo" />
                                    </div>
                                    <div className="col-md-10">
                                        <dl className="row dl-striped mb-0">
                                            {Object.keys(item.jsonData).map((row, index) => (
                                                <Fragment key={index}>
                                                    <dt className={"col-md-3 " + item.jsonData[row]["Class"]}>{Translate(row)}</dt>
                                                    <dd className={"col-md-9 " + item.jsonData[row]["Class"]}>{Translate(item.jsonData[row]["Text"])}</dd>
                                                </Fragment>
                                            ))}
                                        </dl>
                                    </div>
                                </div>
                            </Card>
                        ))}

                    </Fragment>
                )}
            </LanguageConsumer>

        )
    }
}